import React from 'react';
import ChatContainer from '../ChatContainer/ChatContainer';

function SearchAcrossSectionsContainer(props) {
  return <ChatContainer {...props} />;
}

export default SearchAcrossSectionsContainer;
